export function printFloatValue(value: number): string {
  let str = String(value);
  return str.replace(".", ",");
}
